import { linksArray } from "../../components/SideDrawer/NavListItems/NavListArray";

const reportDisplayNameLookup = (reportName) => {
    const match = Object.values(linksArray.reports.children).find(
          (child) => child.path.split('/').pop().toLowerCase() === reportName.toLowerCase()
        );
    return match?.text ?? reportName;
}

export default reportDisplayNameLookup;